import { render, staticRenderFns } from "./PostsGrid.vue?vue&type=template&id=e61da6aa&scoped=true&"
import script from "./PostsGrid.vue?vue&type=script&lang=js&"
export * from "./PostsGrid.vue?vue&type=script&lang=js&"
import style0 from "./PostsGrid.vue?vue&type=style&index=0&id=e61da6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61da6aa",
  null
  
)

export default component.exports